import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { addReportLisitingRequest, deleteAdReport, blockAd } from './redux/adReportDispatcher';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import {  imageBaseUrls, webSiteUrl } from '../../constant/ApiUrls';
import localStorageServices from "../../services/LocalStorage";
import { LocalStorageKeys } from "../../constant/LocalStorageKeys";

function AdReportListingTable() {
  const dispatch = useDispatch();
  const location = useLocation();
  const adReportListing = useSelector(state => state.adReportReducer);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10); 

  // const columns = [
  //   {
  //     field: "id",
  //     headerName: "NO",
  //     width: 60,
  //     renderCell: (params) =>
  //       params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
  //   },
  //   { field: "created_at", headerName: "Created At", width: 100 },

  //   { field: "name", headerName: "Name", width: 150 },
  //   { field: "email", headerName: "Email", width: 150 },
  //   { field: "reason", headerName: "Reason", width: 150 },
  //   { field: "comment", headerName: "Comment", width: 200 },
  //   {
  //     field: "action",
  //     headerName: "Action",
  //     width: 180,
  //     sortable: false,
  //     renderCell: (params) => (
  //       <div style={{ display: "flex", gap: "6px", height: "100%", alignItems: "center" }}>

  //         <button
  //           onClick={() => {
  //             const adId = params.row.ad_id; // Make sure ad_id exists
  //             window.open(`${webSiteUrl}ads/${adId}`, "_blank");
  //           }}
  //           style={{
  //             backgroundColor: "#1976D2",
  //             color: "white",
  //             border: "none",
  //             borderRadius: "4px",
  //             fontSize: "10px",
  //             padding: "4px 8px",
  //             cursor: "pointer",
  //             height: "24px",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //           }}
  //         >
  //           View
  //         </button>



  //       {
  //         (params.row?.adData.status||1)!==3?
          
  //         <button
  //           onClick={() => handleBlock(params.row)}
  //           style={{
  //             backgroundColor: "black",
  //             color: "white",
  //             border: "none",
  //             borderRadius: "4px",
  //             fontSize: "10px",
  //             padding: "4px 8px",
  //             cursor: "pointer",
  //             minWidth: "40px",
  //             height: "24px",  // Increased height
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //           }}
  //         >
  //           Block
  //         </button>:  <button
  //           onClick={()=>{}}
            
  //           style={{
  //             backgroundColor: "black",
  //             color: "white",
  //             border: "none",
  //             borderRadius: "4px",
  //             fontSize: "10px",
  //             padding: "4px 8px",
  //             cursor: "pointer",
  //             minWidth: "40px",
  //             height: "24px",  // Increased height
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //           }}
  //         >
  //           Blocked
  //         </button>
  //       }


  //         <button
  //           onClick={() => handleDelete(params.row)}
  //           style={{
  //             backgroundColor: "#F44336",
  //             color: "white",
  //             border: "none",
  //             borderRadius: "4px",
  //             fontSize: "10px",
  //             padding: "4px 8px",
  //             cursor: "pointer",
  //             minWidth: "40px",
  //             height: "24px",  // Increased height
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //           }}
  //         >
  //           Delete
  //         </button>


  //       </div>
  //     )
  //   }
  // ];


  const columns = [
    // {
    //   field: "id",
    //   headerName: "NO",
    //   width: 60,
    //   renderCell: (params) =>
    //     params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
    // },
    // { field: "created_at", headerName: "Created At", width: 100 },

    // { field: "name", headerName: "Name", width: 150 },
    // { field: "email", headerName: "Email", width: 150 },
    // { field: "reason", headerName: "Reason", width: 150 },
    // { field: "comment", headerName: "Comment", width: 200 },
    {
      field: "action",
      headerName: "Reports",
      
      flex:1,
      sortable: false,
renderCell: (params) => {


  return (
    <div
      style={{
        width: "100%",
        padding: "10px",
        display: "flex",
        flexDirection: "row",
        gap: "8px",
        background: "#fafafa",
         justifyContent: "space-between",
        fontSize: "12px",
      }}
    >
  {/* 1️⃣ Ad Details */}
<div
  style={{
    display: "flex",
    flex: 3,
    justifyContent: "space-between",
    lineHeight: 1.4,
  }}
>
  <div>
   <div>

     {/* ✅ Show Ad Image on top */}
    {params.row.adImages && (() => {
      try {
        const images = JSON.parse(params.row.adImages); // convert string to array
        return images.length > 0 ? (
          <img
            src={`${imageBaseUrls(images[0])}`} // prepend base url if needed
            alt="Ad"
            style={{
              width: "100px",
              height: "80px",
              objectFit: "cover",
              marginBottom: "8px",
              borderRadius: "4px",
            }}
          />
        ) : null;
      } catch (e) {
        console.error("Invalid adImages:", e);
        return null;
      }
    })()}
   </div>

    <a
      href={`${webSiteUrl}ads/${params.row.ad_id}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        fontSize: "13px",
        textDecoration: "none",
        color: "#1976d2",
        cursor: "pointer",
      }}
    >
      {params.row.title || "Untitled Ad"}
    </a>

    

     <div style={{ fontSize: "11px" }}>
      <strong>Category:</strong> {params.row.lastCategoryName}
    </div>

    <div style={{ fontSize: "11px", color: "#666" }}>
    <strong>Published:</strong>   {new Date(params.row.ad_published_at).toLocaleDateString()}
    </div>

    
    
  </div>
</div>

      {/* 2️⃣ Reporter */}
      <div style={{flex:2, display:'flex', flexDirection:"column", lineHeight:1.4}}>
        <div style={{ fontWeight: "bold", marginBottom: "2px" }}>Reporter</div>
        <div>{params.row.userName || "Unknown"}</div>
        <div><a 
              href={`mailto:${params.row.userEmail}`}   >{params.row.userEmail || "Unknown"} </a></div>
      
     <div style={{ fontSize: "11px", color: "#666" }}>
          <strong>Joined:{" "}</strong>
        
             {new Date(params.row.user_joined_at).toLocaleDateString()}
        </div>
    
      <div style={{ fontSize: "11px", color: "#666" }}>
      <strong>Reported:{" "}</strong>
      {params.row.created_at
        ? new Date(params.row.created_at).toLocaleString()
        : "N/A"}
    </div>

    
    <div style={{ fontSize: "11px" }}>
      <strong>Reason:</strong> {params.row.reason}
    </div>
    <div style={{ fontSize: "11px", whiteSpace: "normal" }}>
      <strong>Comment:</strong> {params.row.comment}
    </div>
       
      </div>

      {/* 3️⃣ Reported User */}
      <div style={{flex:2, display:'flex', flexDirection:"column", lineHeight:1.4}}>
        <div style={{ fontWeight: "bold", marginBottom: "2px" }}>
          Reported User
        </div>
        <div>{params.row.reporedName || "Unknown"}</div>
        {/* <div>{params.row.reportedEmail || "Unknown"}</div> */}
        <div><a 
              href={`mailto:${params.row.reportedEmail}`}  >{params.row.reportedEmail || "Unknown"} </a></div>
        <div style={{ fontSize: "11px", color: "#666" }}>
          Joined:{" "}
          { new Date(params.row.joined_at).toLocaleDateString()}
        </div>
        {/* <div style={{ fontSize: "11px", color: "#666" }}>
          Ads: {adOwner?.adsCount ?? 0}
        </div> */}
      </div>



{/* 4️⃣ Blocked By Admin */}
{(params.row.adStatus || 1) === 3&& <div style={{ flex: 2, display: 'flex', flexDirection: "column", lineHeight: 1.4 }}>
  <div style={{ fontWeight: "bold", marginBottom: "2px" }}>
    Blocked By
  </div>
  <div>{params.row.blockedAdminName || "Unknown"}</div>
  <div>
    {params.row.blockedAdminEmail ? (
      <a href={`mailto:${params.row.blockedAdminEmail}`}>
        {params.row.blockedAdminEmail}
      </a>
    ) : (
      "Unknown"
    )}
  </div>
  <div style={{ fontSize: "11px", color: "#666" }}>
    {params.row.blocked_by ? `Admin ID: ${params.row.blocked_by}` : ""}
  </div>
</div>}



      {/* 4️⃣ Actions */}
      <div style={{ display: "flex",  gap: "6px" , width:"100px", flexDirection:"column", lineHeight:1.4}}>
        {(params.row.adStatus || 1) !== 3 ? (
          <button
            onClick={() => handleBlock(params.row)}
            style={{
              backgroundColor: "black",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "50px",
              height: "22px",
            }}
          >
            Block
          </button>
        ) : (
          <button
            disabled
            style={{
              backgroundColor: "gray",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              minWidth: "50px",
              height: "22px",
            }}
          >
            Blocked
          </button>
        )}

        <button
          onClick={() => handleDelete(params.row)}
          style={{
            backgroundColor: "#F44336",
            color: "white",
            border: "none",
            borderRadius: "4px",
            fontSize: "10px",
            padding: "4px 8px",
            cursor: "pointer",
            minWidth: "50px",
            height: "22px",
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
      // renderCell: (params) => (
      //   <div style={{ display: "flex", gap: "6px", height: "100%", alignItems: "center" }}>
          
      //     <button
      //       onClick={() => {
      //         const adId = params.row.ad_id; // Make sure ad_id exists
      //         window.open(`${webSiteUrl}ads/${adId}`, "_blank");
      //       }}
      //       style={{
      //         backgroundColor: "#1976D2",
      //         color: "white",
      //         border: "none",
      //         borderRadius: "4px",
      //         fontSize: "10px",
      //         padding: "4px 8px",
      //         cursor: "pointer",
      //         height: "24px",
      //         display: "flex",
      //         alignItems: "center",
      //         justifyContent: "center",
      //       }}
      //     >
      //       View
      //     </button>



      //   {
      //     (params.row?.adData.status||1)!==3?
          
      //     <button
      //       onClick={() => handleBlock(params.row)}
      //       style={{
      //         backgroundColor: "black",
      //         color: "white",
      //         border: "none",
      //         borderRadius: "4px",
      //         fontSize: "10px",
      //         padding: "4px 8px",
      //         cursor: "pointer",
      //         minWidth: "40px",
      //         height: "24px",  // Increased height
      //         display: "flex",
      //         alignItems: "center",
      //         justifyContent: "center",
      //       }}
      //     >
      //       Block
      //     </button>:  <button
      //       onClick={()=>{}}
            
      //       style={{
      //         backgroundColor: "black",
      //         color: "white",
      //         border: "none",
      //         borderRadius: "4px",
      //         fontSize: "10px",
      //         padding: "4px 8px",
      //         cursor: "pointer",
      //         minWidth: "40px",
      //         height: "24px",  // Increased height
      //         display: "flex",
      //         alignItems: "center",
      //         justifyContent: "center",
      //       }}
      //     >
      //       Blocked
      //     </button>
      //   }


      //     <button
      //       onClick={() => handleDelete(params.row)}
      //       style={{
      //         backgroundColor: "#F44336",
      //         color: "white",
      //         border: "none",
      //         borderRadius: "4px",
      //         fontSize: "10px",
      //         padding: "4px 8px",
      //         cursor: "pointer",
      //         minWidth: "40px",
      //         height: "24px",  // Increased height
      //         display: "flex",
      //         alignItems: "center",
      //         justifyContent: "center",
      //       }}
      //     >
      //       Delete
      //     </button>


      //   </div>
      // )
    }
  ];





  const handleDelete = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to delete this "${row.reason}" report`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(deleteAdReport(row.id));
      }
    });
  };


  const handleBlock = (row) => {
    Swal.fire({
      title: '',
      html:   `Are you sure?<br>You want to block this Ad` ,
      showCancelButton: true,
      confirmButtonText: 'Yes, Block',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {

                 const userInfo = localStorageServices.getItem(LocalStorageKeys.userInfo);

        console.log("DATATATATT:::::${}",userInfo)
        // var data = {
        //     id: row.ad_id,
        //     status:1,
        //   };

        //   dispatch(blockAd(data));



         var data = {
            id: row.ad_id,
            status:3,
            blocked_by:userInfo.id,
          };

          dispatch(blockAd(data));
      
      }
    });
  };








  useEffect(() => {
    dispatch(addReportLisitingRequest(page + 1, pageSize));

  }, [page, pageSize, dispatch, location.pathname]);



  return (
    <Paper sx={{ height: "95%", width: '100%' }}>

      <DataGrid
        rows={adReportListing.adReportListing || []}
        columns={columns}
        rowCount={adReportListing.totalAdReport || 0}
        paginationModel={{ page, pageSize }}
        paginationMode="server"
        onPaginationModelChange={({ page, pageSize }) => {
          console.log("pagination----", page, pageSize);
          setPage(page);
          setPageSize(pageSize);
        }}
        pageSizeOptions={[10, 25, 50]}
        loading={adReportListing.loading}
        rowHeight={190}  
        //  getRowHeight={() => 'auto'}   
        // autoHeight
        disableRowSelectionOnClick
      />
    </Paper>
  );
}

export default AdReportListingTable;
